import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 7v3h3l3 -3h-3v-3l-3 3","key":"svg-0"}],["path",{"d":"M14 10l-9 9","key":"svg-1"}],["path",{"d":"M5 15v4h4","key":"svg-2"}]]

const IconArcheryArrow = createReactComponent('outline', 'archery-arrow', 'ArcheryArrow', __iconNode);

export default IconArcheryArrow;